import { StatusEnum } from '../../Enum/StatusEnum';
import BaseEntity from '../BaseEntity.model';
import { CreatedBy } from '../Shared/CreatedBy.model';
import { AbuseHistoryItem } from './AbuseHistoryItem.model';

export default interface IAbuseHistoryModel extends BaseEntity {
    MemberId: string;
    MemberName: string;
    CreatedDate: Date;
    CreatedBy: CreatedBy;
    UpdatedDate: Date;
    UpdatedBy: CreatedBy;

    ViolentCrimeOrTerrorism: string;
    ViolentCrimeOrTerrorismDescription: string;
    IsAIViolentCrimeOrTerrorism: boolean;
    IsAIViolentCrimeOrTerrorismDescription: boolean;

    HistoryOfAbuse: string;
    AbuseHistoryList: AbuseHistoryItem[];
    IsAIHistoryOfAbuse: boolean;
    IsAIAbuseHistoryList: boolean;

    AssessmentStatus: StatusEnum;
}

export class AbuseHistoryModel implements IAbuseHistoryModel {
    Id: string;
    MemberId: string;
    MemberName: string;
    CreatedDate: Date;
    CreatedBy: CreatedBy;
    UpdatedDate: Date;
    UpdatedBy: CreatedBy;

    ViolentCrimeOrTerrorism: string;
    ViolentCrimeOrTerrorismDescription: string;
    IsAIViolentCrimeOrTerrorism: boolean;
    IsAIViolentCrimeOrTerrorismDescription: boolean;

    HistoryOfAbuse: string;
    AbuseHistoryList: AbuseHistoryItem[];
    IsAIHistoryOfAbuse: boolean;
    IsAIAbuseHistoryList: boolean;

    AssessmentStatus: StatusEnum;

    constructor() {
        this.Id = '';
        this.MemberId = '';
        this.MemberName = '';
        this.ViolentCrimeOrTerrorism = '';
        this.ViolentCrimeOrTerrorismDescription = '';
        this.IsAIViolentCrimeOrTerrorism = false;
        this.IsAIViolentCrimeOrTerrorismDescription = false;
        this.HistoryOfAbuse = '';
        this.IsAIHistoryOfAbuse = false;
        this.AbuseHistoryList = [];
        this.IsAIAbuseHistoryList = false;
        // this.PhysicalSexualAbuseMinor = false;

        // this.PhysicalAbuseAdult = false;
        // this.DomesticViolenceAbuse = false;
        // this.CommunityViolence = false;
        // this.NeglectAsChild = false;
        // this.NeglectAsDisabledAdult = false;
        // this.EmotionalAbuseChild = false;
        // this.ElderAbuse = false;
        // this.SexualAbuseMolestation = false;
        // this.AbuseHistoryOther = false;
        // this.AbuseHistoryOtherDescription = '';
        // this.AbuseHistoryComment = '';

        this.AssessmentStatus = 0;
    }
}
